module.exports = __webpack_public_path__ + "static/img/31.2dc786a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/31.png
// module id = 5ZVP
// module chunks = 0